import { render, staticRenderFns } from "./Testimonials.vue?vue&type=template&id=2456e3ee&scoped=true"
import script from "./Testimonials.js?vue&type=script&lang=js&external"
export * from "./Testimonials.js?vue&type=script&lang=js&external"
import style0 from "./Testimonials.scss?vue&type=style&index=0&id=2456e3ee&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2456e3ee",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotCarousel: require('/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Molecules/Carousel/Carousel.vue').default,HotContainer: require('/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Templates/Container/Container.vue').default})
